import BolProduct, {ProductStatus} from '../models/bolProductModel';
import User from '../models/userModel';

export type {ProductStatus};

export type ProductVisibility = 'all' | 'visible' | 'hidden';
export type ProductGroupItem = {product: BolProduct; index: number};
export type ProductGroup = {key: ProductVisibility; items: ProductGroupItem[]};

export const HIDE_CONFIRM_DISMISSED_FLEX_KEY = 'products_hide_confirm_dismissed';
export const PRODUCTS_INTRO_SEEN_FLEX_KEY = 'products_intro_seen';
const GROUP_ORDER: ProductVisibility[] = ['visible', 'hidden'];

export function getProductStatus(product: BolProduct): ProductStatus {
    return product.visibilityStatus;
}

export function groupProductsByStatus(
    products: BolProduct[],
    statusByEan: Record<string, ProductStatus>,
    visibility: ProductVisibility
): ProductGroup[] {
    if (visibility === 'all')
        return products.length ? [{key: 'all', items: products.map((product, index) => ({product, index}))}] : [];
    const groups: Record<ProductVisibility, ProductGroupItem[]> = {all: [], visible: [], hidden: []};
    products.forEach((product, index) => {
        groups[groupKeyForStatus(statusByEan[product.ean] ?? 'visible')].push({product, index});
    });
    return GROUP_ORDER.filter(key => groups[key].length).map(key => ({key, items: groups[key]}));
}

function groupKeyForStatus(status: ProductStatus): Exclude<ProductVisibility, 'all'> {
    return status === 'visible' ? 'visible' : 'hidden';
}

export function matchesVisibility(status: ProductStatus, visibility: ProductVisibility): boolean {
    if (visibility === 'all') return true;
    return groupKeyForStatus(status) === visibility;
}

export const DIALOG_TITLE_NAME_LENGTH = 40;

export function truncateProductName(name: string, maxLength: number = DIALOG_TITLE_NAME_LENGTH): string {
    if (name.length <= maxLength) return name;
    return `${name.slice(0, maxLength).trimEnd()}…`;
}

export function shouldConfirmHide(user: User | null): boolean {
    return user?.getFlex(HIDE_CONFIRM_DISMISSED_FLEX_KEY) !== true;
}

export function shouldShowProductsIntro(user: User | null): boolean {
    return !!user && user.getFlex(PRODUCTS_INTRO_SEEN_FLEX_KEY) !== true;
}
